import { FieldValidationResult } from './field-validation-result';
import { Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { map, catchError } from 'rxjs/operators';

import { Router } from '@angular/router';
import { SecurityService } from '@core/Security/security.service';
import { ConfigService } from '../config.service';
import { EventsEmitterService } from '../emitter.service';
import { LogService } from '../log.service';

@Injectable()

export class ValidatorsService extends SecurityService {

    constructor(http: HttpClient, configService: ConfigService, eventsEmitterService: EventsEmitterService, router: Router, logger: LogService) {
        super(http, configService, eventsEmitterService, router, logger);
    }

    validateIban(bean: any): Observable<FieldValidationResult> {
        let serviceUrl = this.configService.getServer() + 'ValidatorService/validateIban';
        return this.http.post<any>(serviceUrl, bean).pipe(map(response => { return response.data; }),catchError(this.handleError));
    }
}